import React, { useState, useEffect } from "react";
import axios from "axios";
import { BASE_URL } from "../../../constants";
import { Container, Card, Row, Col, Button, InputGroup } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import Select from 'react-select';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { downloadNorExclPDF } from "./DownloadNorExcl_PDF";
import { printPDF } from "./PrintPDF";

const Daily_Fee_Register = () => {

  const today = new Date().toISOString().split("T")[0];
  const [selectedSection, setSelectedSection] = useState();
  const [ddlSections, setDdlSections] = useState([]);
  const [fromDate, setFromDate] = useState(today);
  const [toDate, setToDate] = useState(today);
  const [reportData, setReportData] = useState([]);
  const [dynamicColumns, setDynamicColumns] = useState([]);
  const [normalExclRpt, setNormalExclRpt] = useState('');
  const [summReportData, setSummReportData] = useState([]);

  const fixedColumns = [
    "Date",
    "Receipt No",
    "GR No",
    "Std/Div",
    "Period"
  ];


  useEffect(() => {

    loadDropdowns();

  }, []);

  const loadDropdowns = async () => {
    try {

      const sec = await axios.get(`${BASE_URL}/api/ddl_sections`);
      setDdlSections(sec.data);

    } catch (err) {
      console.error(err);
    }

  };

  const selectedSectionName = ddlSections.find(sec => sec.section_id === Number(selectedSection))?.section_desc || "Not Defined";

  // Fetch report
  const handleNormalReport = async () => {

    if (!selectedSection || selectedSection === '') {
      toast.error("Please select Section.");
      return;      
    }
    if (fromDate > toDate) {
      toast.error("From Date cannot be greater than To Date.");
      return;
    }

    setNormalExclRpt('N');

    callNormalExclReport('N');

  };

  const handleExclusiveReport = async () => {

    if (!selectedSection || selectedSection === '') {
      toast.error("Please select Section.");
      return;      
    }
    if (fromDate > toDate) {
      toast.error("From Date cannot be greater than To Date.");
      return;
    } 

    setNormalExclRpt('E');
    callNormalExclReport('E');

  };

  const callNormalExclReport = async(p_nor_excl) => {

    try {
      setDynamicColumns([]);
      setReportData([]);
      setSummReportData([]);
      const res = await axios.get(`${BASE_URL}/api/rpt_daily_fee_register`, {
        params: {
          p_section_id: selectedSection,
          p_from_date: fromDate,
          p_to_date: toDate,
          p_normal_excl: p_nor_excl
        }
      });

      if (res.data.rows.length > 0) {
        setDynamicColumns(res.data.dynamicColumns);
        setReportData(res.data.rows);
        setSummReportData(res.data.summary);
      } else {
        setDynamicColumns([]);
        setReportData([]);
        setSummReportData([]);
        toast.error("No Records Found");
      }

    } catch (err) {
      console.error("Report Error:", err);
      toast.error("Error loading Report.");
    }

  }

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);

    const day = String(date.getDate()).padStart(2, "0");
    const month = date.toLocaleString("en-US", { month: "short" }); // Jan, Feb, etc.
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  const formatDateForFile = (dateStr) => {
    const [year, month, day] = dateStr.split("-"); // safest approach
    return `${day}-${month}-${year}`;
  };

  /// Dynamic Footer Totals
  const footerTotals = {};

  dynamicColumns.forEach(col => {
    footerTotals[col] = 0;
  });

  reportData.forEach(row => {
    dynamicColumns.forEach(col => {
      footerTotals[col] += Number(row.fee_heads?.[col] || 0);
    });
  });

  const formatAmount = (amount) =>
    Number(amount || 0).toLocaleString("en-IN", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });

  const handlePrintPDF = () => {

    if (reportData.length === 0) {
      toast.warning("No data to download");
      return;
    }

    let lv_section;

    lv_section = selectedSectionName;

    if (selectedSection > 3) {
      lv_section = 'Junior College';
    } 

    if (normalExclRpt === 'N' || normalExclRpt === 'E') {
      printPDF({
        reportData,
        dynamicColumns,
        footerTotals,
        summReportData,
        fromDate,
        toDate,
        selectedSectionName: lv_section
      });
    }

  };

  const handleDownloadPDF = () => {

    if (reportData.length === 0) {
      toast.warning("No data to download");
      return;
    }

    if (normalExclRpt === 'N' || normalExclRpt === 'E') {
      downloadNorExclPDF({ 
        reportData, 
        dynamicColumns, 
        footerTotals, 
        summReportData, 
        fromDate, 
        toDate, 
        selectedSectionName });
    }

  };

  return (

    <Container fluid className="p-3">

      {/* Filters */}
      <Card className="p-3 mb-3">
        <Row>

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text style={{ width: "80px" }}> Section 
              </InputGroup.Text>

              <select className="form-select" name="selectedSection" 
                value={selectedSection} onChange={(e) => setSelectedSection(e.target.value)} >
                <option value="">Select</option>
                {ddlSections.map(s => (
                  <option key={s.section_id} value={s.section_id}>{s.section_desc}</option>
                ))}
              </select>
            </InputGroup>
          </Col>

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text style={{ width: "120px" }}>From Date</InputGroup.Text>
              <input
                type="date"
                className="form-control"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
            </InputGroup>
          </Col>

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text style={{ width: "120px" }}>To Date</InputGroup.Text>
              <input
                type="date"
                className="form-control"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
              />
            </InputGroup>
          </Col>
        </Row>

        <Row className="mt-3">
          <Col md={12} className="d-flex justify-content-end">
            <Button variant="success" className="ms-2"
              disabled={reportData.length === 0} onClick={handlePrintPDF} > 🖨️ Print
            </Button>
            <Button variant="primary" className="ms-2"
              disabled={reportData.length === 0} onClick={handleDownloadPDF} > Download PDF
            </Button>
            {/* <Button variant="success" onClick={handleNormalReport} 
            className="ms-2">
              Run Report
            </Button> */}

            <Button variant="success" onClick={handleExclusiveReport} className="ms-2">
              Run Report
            </Button>

            {/* <Button variant="primary" onClick={handleRunReport} className="ms-2">
              User-Wise Report
            </Button> */}

          </Col>

        </Row>

      </Card>

      {/* Report Table */}
      <Card className="p-3">
        <div style={{ minHeight: '220px' }} className="table-responsive">

         <table style={{ maxHeight: '35px' }} className="responsive-table scty-custom-table-rcpt hover-table-rcpt">
            <thead className="table-light">
              <tr>

                <th style={{ fontSize: '13px', width: '8%', textAlign: 'center' }} >Date </th>
                <th style={{ fontSize: '13px', width: '7%', textAlign: 'left' }} >Rcpt No.</th>
                <th style={{ fontSize: '13px', width: '7%', textAlign: 'center' }} >GR No </th>
                <th style={{ fontSize: '13px', width: '8%', textAlign: 'left' }} >Std / Div </th>
                <th style={{ fontSize: '13px', width: '9%', textAlign: 'left' }} >Period </th>
                
                {dynamicColumns.map(col => (
                  <th style={{ fontSize: '13px', width: "8%", textAlign: "center", whiteSpace: "normal", overflowWrap: "normal", wordBreak: "normal" }}
                     key={col}>{col}</th>
                ))}
                <th style={{ width: '10%', textAlign: 'right' }} >Total</th>
              </tr>
            </thead>

            <tbody>
              {
                reportData.map(row => (
                //rows.map(row => (
                  <tr key={row.rcpt_no} >
                    <td style={{ fontSize: '13px', textAlign: 'center', whiteSpace: "normal",
                      overflowWrap: "break-word", wordBreak: "break-word" }} > {row.rcpt_date}</td>

                    <td style={{ fontSize: '13px', textAlign: 'left', whiteSpace: "normal",  
                       overflowWrap: "break-word", wordBreak: "break-word" }}> {row.rcpt_no}</td>

                    <td style={{ fontSize: '13px', textAlign: 'center' }}>{row.gr_no}</td>

                    <td style={{ fontSize: '13px', textAlign: 'left', whiteSpace: "normal",  
                      overflowWrap: "break-word", wordBreak: "break-word" }}> {row.std_div}</td>

                    <td style={{ fontSize: '13px', textAlign: 'left',whiteSpace: "normal", 
                      overflowWrap: "break-word", wordBreak: "break-word" }}> {row.from_period}</td>
                    {
                      dynamicColumns.map(col => (
                        <td style={{ fontSize: '13px', textAlign: 'right' }} key={col}>
                          {formatAmount(row.fee_heads[col]) || 0}
                        </td>
                      ))
                    }

                    <td style={{ fontSize: '13px', textAlign: 'right', fontWeight: 'bold' }} >{formatAmount(row.tot_amt)}</td>
                  </tr>
                ))
              }
            </tbody>
            <tfoot>
              <tr style={{ backgroundColor: "#e9ecef", fontWeight: "bold" }}>
                <td colSpan="5" style={{ fontSize: '14px'}}>Total : </td>

                {
                  dynamicColumns.map(col => (
                    <td style={{ textAlign: 'right' }} key={col}>
                      {formatAmount(footerTotals[col])}
                    </td>
                  ))
                }

                <td style={{ textAlign: 'right' }} >
                  {formatAmount(
                    Object.values(footerTotals)
                      .reduce((a, b) => a + b, 0))
                  }
                </td>
              </tr>
            </tfoot>
          </table>
        </div>

        {/* Payment Mode Summary  */}
        <div style={{ minHeight: '220px' }} className="mt-3">
          {/* <p><b>House Summary</b></p> */}
          <table className="summary-table scty-custom-table-rcpt hover-table-rcpt"
              style={{ maxHeight: '30px', width: "60%", marginLeft: 0 }} >
            <thead className="table-light">
              <tr>
                <th style={{ textAlign: 'center', width: '15%' }} >Cash</th>
                <th style={{ textAlign: 'center', width: '15%' }} >Cheque</th>
                <th style={{ textAlign: 'center', width: '15%' }} >Online</th>
                <th style={{ textAlign: 'center', width: '15%' }} >NEFT/IMPS</th>
                {/* <th style={{ textAlign: 'center', width: '15%' }} >Others</th> */}
              </tr>
            </thead>
            <tbody>
              {summReportData.length > 0 ? (
                summReportData.map((n, idx) => (
                  <tr key={n.irn}>
                    <td style={{ textAlign: 'right' }}> {formatAmount(n.cash)} </td>
                    <td style={{ textAlign: 'right' }}> {formatAmount(n.cheque)} </td>
                    <td style={{ textAlign: 'right' }}> {formatAmount(n.online)} </td>
                    <td style={{ textAlign: 'right' }}> {formatAmount(n.neft)} </td>
                    {/* <td style={{ textAlign: 'right' }}> {formatAmount(n.others)} </td> */}
                  </tr>
                ))
               ) : (
                <tr>
                  <td colSpan="4" className="text-center">
                  </td>
                </tr>
              )} 
            </tbody>
          </table>
          <Button onClick={handleNormalReport} className="click-button"> .
          </Button>          

        </div>
      </Card>

    </Container>
  );
};

export default Daily_Fee_Register;
